class WishlistButton {
  /**
   * @param {HTMLButtonElement} container – The button instance
   * @param {Object} swat
   * @param {string} productId
   */
  constructor(container, swat = window._swat, productId) {
    this.container = container;
    this.productId = productId || container.dataset.productId;
    this.swat = swat;

    if (!this.container) {
      console.warn(`[Wishlist Button] missing container`, container);
      return;
    }

    if (!this.swat) {
      console.warn(`[Wishlist Button] missing swat instance`, container);
      return;
    }

    this.clicked = this.clicked.bind(this);
    this.removeFromWishlist = this.removeFromWishlist.bind(this);
    this.addToWishlist = this.addToWishlist.bind(this);

    this.container.addEventListener('click', this.clicked);
  }

  get addedToWishlist() {
    return this.container.dataset.addedToWishlist === 'true';
  }

  set addedToWishlist(added) {
    this.container.dataset.addedToWishlist = added.toString();
  }

  get itemData() {
    if (this.wishlistItemData) return this.wishlistItemData;
    const itemData = window.SwymPageData;
    if (itemData.du.startsWith('//')) {
      itemData.du = `https:${itemData.du}`;
    }
    return itemData;
  }

  clicked() {
    if (this.addedToWishlist) {
      this.removeFromWishlist();
    } else {
      this.addToWishlist();
    }
  }

  addToWishlist() {
    if (!this.itemData) return;

    this.swat.addToWishList(
      this.itemData,
      () => {
        console.log('added to wishlist');
        this.addedToWishlist = true;
      },
      false
    );
  }

  removeFromWishlist() {
    if (!this.itemData) return;
    this.swat.removeFromWishList(
      {
        epi: this.itemData.epi,
        du: this.itemData.du,
        empi: this.itemData.empi,
        iu: this.itemData.iu,
        pr: this.itemData.pr,
      },
      () => {
        this.addedToWishlist = false;
      }
    );
  }
}

const selectors = {
  secondaryQuantity: '.js-product-quantity--secondary input',
  primaryQuantity: '.js-product-quantity--primary input',
  wishlistButton: '.js-wishlist-button',
  wishlistButtonWrapper: '.js-wishlist-button-wrapper',
  productForm: '.js-product-form',
};

class ProductDetail {
  /**
   * @param {HTMLDivElement}
   */
  constructor(el) {
    const { primaryQuantity, secondaryQuantity, wishlistButton } = selectors;

    console.log(`[Product Detail] initialized with container`, el);

    this.container = el;
    this.primaryQuantitySelector = el.querySelector(primaryQuantity);
    this.secondaryQuantitySelector = el.querySelector(secondaryQuantity);
    this.wishlistButtons = el.querySelectorAll(wishlistButton);

    this.initQuantitySelector = this.initQuantitySelector.bind(this);
    this.initWishlistButton = this.initWishlistButton.bind(this);
    this.useSwat = this.useSwat.bind(this);

    this.productId = this.container.dataset.productId;
    this.productUrl = this.container.dataset.productUrl;

    this.initQuantitySelector();
    this.initWishlistButton();
  }

  static init() {
    const containers = document.querySelectorAll('.js-product-page');
    const instances = Array.from(containers).map(
      (container) => new ProductDetail(container)
    );
    if (process.env.NODE_ENV === 'development') {
      window.ProductDetailInstances ||= [];
      window.ProductDetailInstances = instances;
    }
  }

  initQuantitySelector() {
    if (!this.primaryQuantitySelector || !this.secondaryQuantitySelector) {
      console.warn('[Product Detail] Missing qty selectors', this.container);
      return;
    }

    this.secondaryQuantitySelector.addEventListener(
      'cart:quantity.product',
      () => {
        const value = this.secondaryQuantitySelector.value;
        this.primaryQuantitySelector.setAttribute('value', value);
        this.primaryQuantitySelector.setAttribute('data-value', value);
        this.primaryQuantitySelector.value = value;
      }
    );
  }

  initWishlistButton() {
    if (!this.wishlistButtons.length) {
      console.warn(`[Product Detail] missing wishlist button`, this.container);
      return;
    }

    this.useSwat((swat) => {
      swat.initializeActionButtons(selectors.wishlistButtonWrapper);
      // const wishlistButtons = Array.from(this.wishlistButtons).map(
      //   (button) => new WishlistButton(button, swat, this.productId)
      // );

      // swat.fetchWrtEventTypeET((products) => {
      //   const activeProductId = SwymPageData.empi;
      //   const activeVariantId = SwymPageData.epi;
      //   const isInWishlist = products.some(
      //     (p) => p.empi === activeProductId && p.epi === activeVariantId
      //   );
      //   wishlistButtons.forEach(
      //     (button) => (button.addedToWishlist = isInWishlist)
      //   );
      // }, 4);
    });
  }

  useSwat(callback) {
    let timeout;

    const check = () => {
      if (window._swat) {
        callback(window._swat);
        clearTimeout(timeout);
        return;
      }

      timeout = setTimeout(check, 100);
    };

    check();
  }
}
